<template>
  <div>
    <div class="base-config__line" v-for="(lineData, i) in configLines" :key="i">
      <ConfigForms ref="lineForms" labelWidth="110px" :formItems="configLineItems" :data="lineData"></ConfigForms>
      <div class="base-config__btns">
        <DebounceButton v-if="lineData.id" icon="el-icon-refresh" type="success" size="mini" :time="5000"
          @click="checkConfigLine(lineData, i)">校验</DebounceButton>
        <el-button v-if="i > 0" icon="el-icon-delete" type="danger" size="mini" @click="delConfigLine(i)">删除</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import ConfigForms from '@/components/config-forms';
import { chatTypeOptions } from '../../config/system';
import systemManageApi from '../../../api/systemManage';
import DebounceButton from '../../../components/debounce-button.vue';

const configLineItems = [
  { type: 'text', label: 'API链接配置', required: true, key: 'url' },
  { type: 'text', label: '模型配置', required: true, key: 'module' },
  { type: 'number', label: '权重配置', required: true, key: 'weight' },
  { type: 'switch', label: '状态配置', required: true, key: 'status' },
  // { type: 'select', label: '模型系列', required: true, key: 'modelType', options: modelTypeOptions },
  { type: 'text', label: 'csrfToken配置', required: true, key: 'csrfToken' },
  { type: 'text', label: 'cookie配置', required: true, key: 'sessionCookie' },
  { type: 'select', label: '聊天类型', required: true, key: 'chatType', options: chatTypeOptions },
  { type: 'string', label: '模型API', required: true, key: 'customURL' },
  { type: 'switch', label: '是否流式传输', required: false, width: '160px', contentWidth: '50px', key: 'isStream' },
  { type: 'switch', label: '校验状态', required: false, disabled: true, width: '160px', contentWidth: '50px', key: 'checkState' },
]
export default {
  name: 'SystemConfig',
  emit: ['del'],
  components: { ConfigForms, DebounceButton },
  props: {
    configLines: {
      type: Array,
      default() {
        return [{}]
      }
    },
    cid: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      configLineItems,
    };
  },
  watch: {
  },
  computed: {
  },
  created() {

  },
  methods: {
    async checkLastConfigLine() {
      const lastIndex = this.$refs.lineForms.length - 1
      await this.$refs.lineForms[lastIndex].validate()
    },
    async validateAllConfig() {
      const baseConfig = await Promise.all(this.$refs.lineForms.map(v => v.validate()))
      return baseConfig
    },
    delConfigLine(index) {
      // this.configLines.splice(index, 1)
      this.$emit('del', index)
    },
    async checkConfigLine(item) {
      try {
        const r = await systemManageApi.checkSysConfig({ cid: this.cid, bid: item.id })
        if (r.code === 200) {
          this.$message.success('校验成功！')
        } else {
          this.$message.error('校验失败')
        }
      } catch (err) {
        console.log(err);
        this.$message.error(err)
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-edit-system {
  /deep/ .el-date-editor.el-input {
    width: 200px;
  }

  /deep/ .el-dialog__header {
    position: sticky;
    top: 0;
    background: white;
    z-index: 10;
  }

  /deep/ .el-dialog__footer {
    position: sticky;
    bottom: 0;
    background: white;
  }

  .base-config__add {
    position: absolute;
    top: -35px;
    left: 110px;
  }

  .base-config__line {
    display: flex;
    align-items: center;
    background-color: #0001;
    padding: 15px 0 0;
    border-radius: 10px;
    margin-bottom: 10px;

    /deep/ .el-form-item {
      margin-bottom: 20px;
    }
  }

  .base-config__btns {
    /deep/ .el-button {
      margin-left: 0;
      margin-right: 15px;
    }
  }
}
</style>
